import { useEffect, useState } from "react";

function SmartSelect({
  txtLabel,
  fetchData,
  onSelect,
  initialValue,
  imagens,

  getOpcoesExtras,
  valorExtraSelecionado,
  onSelectExtra
}) {

  const [itens, setItens] = useState([]);
  const [usarAutoComplete, setUsarAutoComplete] = useState(false);

  useEffect(() => {
    async function carregar() {
      const dados = await fetchData("");
      if (dados.length > 5) {
        setUsarAutoComplete(true);
      } else {
        setItens(dados);
      }
    }
    carregar();
  }, []);

  if (usarAutoComplete) {
    const AutoComplete = require("../autocomplete/index").default;
    return (
      <AutoComplete
        txtLabel={txtLabel}
        fetchData={fetchData}
        onSelect={onSelect}
        initialValue={initialValue}
      />
    );
  }

  const iconeTipo = (tipo) => {
    switch (tipo) {
      case "DI":
        return "💵";
      case "PX":
        return "📱";
      case "CC":
        return "💳";
      case "CD":
        return "🏧";
      case "TF":
        return "🔄";
      case "PR":
        return "📝";
      default:
        return "📌";
    }
  };

  return (
    <div className="smart-select">
      <label>{txtLabel}</label>
      <div className="smart-select-grid">
        {itens.map(item => (
          <div
            key={item.id}
            className={`smart-select-item ${
              initialValue?.id === item.id
                ? "ativo"
                : ""
            }`}
            onClick={() => onSelect(item)}
          >
            <img
              src={imagens[item.index]}
              alt=""
            />
            <span>{item.label}</span>
          </div>
        ))}
      </div>

      {initialValue &&
        getOpcoesExtras &&
        getOpcoesExtras(initialValue).length > 0 && (

          <div className="smart-select-tipos-container">

            <label>
              Forma de Movimentação
            </label>

            <div className="smart-select-tipos">
              {getOpcoesExtras(initialValue).map(opcao => (
                <div
                  key={opcao.value}
                  className={`tipo-chip ${
                    valorExtraSelecionado === opcao.value
                      ? "ativo"
                      : ""
                  }`}
                  onClick={() =>
                    onSelectExtra?.(
                      initialValue,
                      opcao
                    )
                  }
                >
                  <span>
                    {iconeTipo(opcao.value)}
                  </span>

                  <span>
                    {opcao.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
      )}
    </div>
  );
}

export default SmartSelect;